import { Injectable } from '@angular/core';
import { UserProfile } from '@content-platform/web-angular-administration-shared-data-access-graph-api';
import { UserProfileMsGraph } from '../models/ms-graph-api-data';

@Injectable({
  providedIn: 'root'
})
export class MsGraphApiHelper {
  constructor() {}

  // Right now in ms-graph-api.service.ts, we are mapping values from the old Azure AD Graph API to the format from
  // the Microsoft Graph API so that code that relies on the old data structure doesn't break.

  public mapUserProfileToOldGraphApi(newUserProfile: UserProfileMsGraph): UserProfile {
    const oldUserProfile: UserProfile = {
      city: newUserProfile.city,
      companyName: newUserProfile.companyName,
      country: newUserProfile.country,
      displayName: newUserProfile.displayName,
      givenName: newUserProfile.givenName,
      lastDirSyncTime: newUserProfile.lastDirSyncTime,
      mail: newUserProfile.mail,
      mailNickname: newUserProfile.mailNickname,
      objectId: newUserProfile.id,
      manager: !!newUserProfile.manager
        ? this.mapUserProfileToOldGraphApi(newUserProfile.manager)
        : null,
      surname: newUserProfile.surname,
      thumbnailPhotoUrl: newUserProfile.thumbnailPhotoUrl,
      usageLocation: newUserProfile.usageLocation,
      userPrincipalName: newUserProfile.userPrincipalName,
      userType: newUserProfile.userType
    };
    return oldUserProfile;
  }
}
